import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTripleDotsHorizontal1 = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      d='M6 9.5q2 0 2 2v1q0 2-2 2t-2-2v-1q0-2 2-2M12 9.5q2 0 2 2v1q0 2-2 2t-2-2v-1q0-2 2-2M20 11.5q0-2-2-2t-2 2v1q0 2 2 2t2-2z'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTripleDotsHorizontal1)
export default ForwardRef
